import { FunctionComponent } from "react"
import { Button, Col, Row, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import FilterField from "../components/FilterField"
import { Pass } from "../data/models.interface"
import { useGetPassesQuery } from "../hooks/queries/useGetPassesQuery"
import useSessionStorage from "../hooks/useSessionStorage"
import useSort from "../hooks/useSort"
import { filterProperty } from "../utils/StringUtils"

interface IPassesPage {}
const PassesPage: FunctionComponent<IPassesPage> = () => {
	const navigate = useNavigate()
	const passesQuery = useGetPassesQuery()
	const passes = passesQuery.data?.passes
	// loading layout
	if (!passes) return <LoadingLayout />
	// normal layout
	return (
		<Container>
			<h2 className="text-center mt-4">Passes</h2>
			<PassesTable passes={passes} />
			<Row>
				<Col xs="auto">
					<BackButton />
				</Col>
				<Col />
				<Col xs="auto">
					<Button variant="success" onClick={() => navigate("/passes/new")}>
						New
					</Button>
				</Col>
			</Row>
		</Container>
	)
}
export default PassesPage

const LoadingLayout = () => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Passes</h2>
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface IPassesTable {
	passes: Pass[]
}
const PassesTable = ({ passes }: IPassesTable) => {
	const navigate = useNavigate()
	const [nameFilter, setNameFilter] = useSessionStorage("passes-name", "")
	const [typeFilter, setTypeFilter] = useSessionStorage("passes-type", "")
	const [propertyNameFilter, setPropertyNameFilter] = useSessionStorage("passes-propertyName", "")
	const [unitNameFilter, setUnitNameFilter] = useSessionStorage("passes-unitName", "")
	const { sortBy, sort } = useSort<Pass>("name")
	passes = filterProperty(passes, (d) => d.name, nameFilter)
	passes = filterProperty(passes, (d) => d.type, typeFilter)
	passes = filterProperty(passes, (d) => d.propertyName || "", propertyNameFilter)
	passes = filterProperty(passes, (d) => d.unitName || "", unitNameFilter)
	passes = sort(passes)
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					<th onClick={() => sortBy("name")}>Name</th>
					<th onClick={() => sortBy("type")}>Type</th>
					<th onClick={() => sortBy("propertyName")}>Property</th>
					<th onClick={() => sortBy("unitName")}>Unit</th>
				</tr>
				<tr>
					<td>
						<FilterField filter={nameFilter} setFilter={setNameFilter} placeholder="Filter Name" />
					</td>
					<td>
						<FilterField filter={typeFilter} setFilter={setTypeFilter} placeholder="Filter Type" />
					</td>
					<td>
						<FilterField filter={propertyNameFilter} setFilter={setPropertyNameFilter} placeholder="Filter Property" />
					</td>
					<td>
						<FilterField filter={unitNameFilter} setFilter={setUnitNameFilter} placeholder="Filter Unit" />
					</td>
				</tr>
			</thead>
			<tbody>
				{passes?.map((pass) => (
					<tr key={pass.id} onClick={() => navigate(`/passes/${pass.id}`)}>
						<td>{pass.name}</td>
						<td>{pass.type}</td>
						<td>{pass.propertyName}</td>
						<td>{pass.unitName}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const BackButton = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}
